import { useObserver } from "mobx-react"
import * as React from "react"

import Dialog from "~/components/molecules/Dialog"
import RecruitmentCard from "~/components/organisms/RecruitmentCard"
import RecruitmentListCut from "~/components/organisms/RecruitmentListCut"
import { RecruitmentType } from "~/consts"
import { internalLink } from "~/services/helper"
import { useStores } from "~/stores/StoreProvider"

interface Props {
  type: keyof typeof RecruitmentType
  recruitments: any
  inlineOnSp?: boolean
  cardWidthOnPc?: number
  cutPoint?: number
  className?: string
}

const { useState, useEffect } = React

// OPTIMIZE: このコンポーネントにDialogを含めるのは微妙かも
const RecruitmentList = ({ recruitments, type, cutPoint, className }: Props) => {
  const { userStore, favoriteStore } = useStores()
  const [authPromptModalOpen, toggleAuthPromptModal] = useState(false)

  useEffect(() => {
    userStore.fetchLoginUser().then(() => {
      if (userStore.user) {
        favoriteStore.fetch()
      }
    })
  }, [])

  const onClickFavorite = (id: number, type: keyof typeof RecruitmentType) => {
    const isFavorited = favoriteStore.isFavorited(id, type)
    if (userStore.user) {
      favoriteStore.toggleFavorite(type, id, isFavorited)
    } else {
      toggleAuthPromptModal(true)
    }
  }

  return (
    <>
      {useObserver(() =>
        cutPoint === undefined ? (
          recruitments.map((recruitment: any, index: number) => {
            return (
              <RecruitmentCard
                key={index}
                recruitment={recruitment}
                category={type}
                isFavorited={favoriteStore.isFavorited(recruitment.id, type)}
                onClickFavorite={() => onClickFavorite(recruitment.id, type)}
                className={className}
              />
            )
          })
        ) : (
          <RecruitmentListCut cutPoint={cutPoint}>
            {recruitments.map((recruitment: any, index: number) => {
              return (
                <RecruitmentCard
                  key={index}
                  recruitment={recruitment}
                  category={type}
                  isFavorited={favoriteStore.isFavorited(recruitment.id, type)}
                  onClickFavorite={() => onClickFavorite(recruitment.id, type)}
                  className={className}
                />
              )
            })}
          </RecruitmentListCut>
        )
      )}
      <Dialog
        open={authPromptModalOpen}
        heading="登録またはログインが必要です"
        mainAction={{
          label: "登録する",
          action: () => window.open(internalLink(`/auth/register?redirect_after_auth=${location.pathname}`), "_self"),
        }}
        subAction={{
          label: "キャンセル",
          action: () => toggleAuthPromptModal(false),
        }}
      >
        お気に入りを利用するためには、新規登録またはログインが必要です。
      </Dialog>
    </>
  )
}

export default RecruitmentList
